ptz-brand {
    display: flex;
}